import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';

import AppTestHarnessReactV2 from './AppTestHarnessReactV2';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element "#root" not found');
}
const root = ReactDOM.createRoot(container);
root.render(<AppTestHarnessReactV2 />);
